import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { CalendarFilterButton, FilterColors } from "./CalendarFilterButton";
import { useState } from "react";

interface FilterProps {
  filters: {
    courseId: number;
    courseName: string;
    isSelected: boolean;
    color: FilterColors;
  }[];
  onToggleFilter: (courseId: number) => void;
}

export const CalendarFilters = ({ filters, onToggleFilter }: FilterProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="mb-4">
      <div className="flex cursor-pointer items-center justify-between" onClick={() => setIsVisible(!isVisible)}>
        <h3 className="text-lg font-semibold">Filtry</h3>
        {isVisible ? <MdKeyboardArrowUp size={24} /> : <MdKeyboardArrowDown size={24} />}
      </div>
      {isVisible && (
        <div className="mt-2 flex flex-wrap gap-1">
          {filters.map((filter) => (
            <CalendarFilterButton
              key={filter.courseId}
              isActive={filter.isSelected}
              color={filter.color}
              onClick={() => onToggleFilter(filter.courseId)}
            >
              {filter.courseName}
            </CalendarFilterButton>
          ))}
        </div>
      )}
    </div>
  );
};
